import React from "react";
import classNames from "classnames";
import { FinancialAccount } from "@common/types/financialAccount";
import { FinancialConnection } from "@common/types/financialConnection";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { useFinancialAccountSyncTimes } from "@hooks/useFinancialAccountSyncTimes";
import { getSyncBreakdownBullets } from "@helpers/accountSyncTimes";
import { timeAgoInSentence } from "@helpers/date";
import { integrationAccountHasError } from "@helpers/financialAccount";
import { ClockIcon } from "@icons";
import { BrokenConnectionLink } from "../../../financialConnection/BrokenConnectionLink";

interface AccountConnectionStatusProps {
    connection: FinancialConnection | IntegrationConnection;
    account: FinancialAccount;
}

export const AccountConnectionStatus: React.FC<
    AccountConnectionStatusProps
> = ({ connection, account }) => {
    const syncTimes = useFinancialAccountSyncTimes(account);
    const { lastSyncedAt } = syncTimes;
    const integrationAccountWithoutError = account.integrationAccounts?.find(
        (ia) =>
            ia.connectionId === connection.id &&
            !integrationAccountHasError(ia, connection),
    );
    let integrationAccount = integrationAccountWithoutError;
    integrationAccount ??= account.integrationAccounts?.find(
        (ia) => ia.connectionId === connection.id,
    );

    return connection.error || lastSyncedAt ? (
        <div
            className={classNames("account-details__connection", {
                "account-details__connection--error": connection.error,
            })}
        >
            {lastSyncedAt && !connection.error && (
                <Tooltip bullets={getSyncBreakdownBullets(syncTimes)}>
                    <span className="icon-color-gray-700">
                        <ClockIcon height="12" /> Synced{" "}
                        {timeAgoInSentence(lastSyncedAt)}
                    </span>
                </Tooltip>
            )}
            {integrationAccount &&
                integrationAccountHasError(integrationAccount, connection) && (
                    <BrokenConnectionLink
                        connection={connection}
                        integrationAccount={integrationAccount}
                    />
                )}
        </div>
    ) : null;
};
